module.exports = __webpack_public_path__ + "static/media/Ready.b71a9aaa.svg";